'use strict';
var vendorMenuApp = angular.module('vendorMenuApp', ['vendorServices', 'infinite-scroll', 'configService','sharedServices', 'ui.router', "ui.bootstrap", 'sharedFilters', 'ngDialog', 'ui.event', 'ngCookies', '720kb.socialshare', 'ngRoute']);
vendorMenuApp.config(function($interpolateProvider, $stateProvider, $urlRouterProvider, $httpProvider, config, EncryptedLocalStorageProvider, $locationProvider) {
	config.token = localStorage.getItem('token');
	//console.log(config.token,"token",urlCategory,urlCity);
	$urlRouterProvider.otherwise('/');
	$stateProvider.state('main', {
    templateUrl: '../../html/venueMenu.html',
    controller: 'venueMenuController',
    abstract: true,
    reloadOnSearch: false,
    }).state("main.root", {
    url:"/?id={vendor_id}",
  });
    $interpolateProvider.startSymbol('{[');
    $interpolateProvider.endSymbol(']}');
});

vendorMenuApp.controller('venueMenuController', ['$scope', '$stateParams', '$state', '$location', '$interval', '$window', 'config', 'getvenueMenu', '$sce', function($scope, $stateParams, $state, $location, $interval, $window, config, getvenueMenu, $sce) {
	console.log("venueMenuController",$location.search().id)
	$scope.vendorId = $location.search().id;
	$scope.menus = {};
	$scope.menus.menuFiles = [];
	getvenueMenu($scope.vendorId,config.token).success(function (data) {
		console.log(data);
		$scope.menus.menuFiles = data.data;
		angular.forEach($scope.menus.menuFiles,function(value) {
		  if (value.ext == 'pdf') {
		    value.menu_url = $sce.trustAsResourceUrl('http://docs.google.com/gview?url=' + value.menu_url + '&embedded=true');
		  }
		})
	})
	$scope.prevItem = function(e,index) {
	  	var actualImageUrl;
	  	var $this = $(e.target);
	  	var $modal = $this.parents('#menuFileModal');
		var imageExt = $scope.menus.menuFiles[index-1].ext;
	  	var k = index-1;
	  	for( var i=k; i >= 0; i--) {
	  		if ($scope.menus.menuFiles[i].ext != 'pdf') {
	  			var k= i;
	  			break;
	  		}
	  	}
		actualImageUrl = $scope.menus.menuFiles[k].menu_url;
	  	console.log("index",index,k,actualImageUrl)
		$scope.openMenuModal(k,actualImageUrl,'image');
	}
	$scope.nextItem = function(e,index) {
	  	var actualImageUrl;
	  	var $this = $(e.target);
	  	var $modal = $this.parents('#menuFileModal');
		var imageExt = $scope.menus.menuFiles[index+1].ext;
	  	var k = index+1;
	  	for( var i=k; i < $scope.menus.menuFiles.length; i++) {
	  		if ($scope.menus.menuFiles[i].ext != 'pdf') {
	  			var k= i;
	  			break;
	  		}
	  	}
		actualImageUrl = $scope.menus.menuFiles[k].menu_url;
	  	console.log("index",index,k,actualImageUrl)
		$scope.openMenuModal(k,actualImageUrl,'image');
	}
	$scope.openMenuModal = function(e, url, type) {
	    console.log("e:",e,"url:",url,"type:",type)
	    if (type == 'pdf') {
	        $scope.pdf = true;
	        $scope.menuModalUrl = $sce.trustAsResourceUrl('http://docs.google.com/gview?url=' + url + '&output=embed');
	    } else {
	        $scope.pdf = false;
	        $scope.menuModalUrl = url;
	        $scope.indexValue = e;
	    }
	    $('#menuFileModal').modal('show');
    	var k = e;
    	var prevImageType = k == 1 ? $scope.menus.menuFiles[k-1].ext : false;
    	var nextImageType = k == $scope.menus.menuFiles.length-2 ? $scope.menus.menuFiles[k+1].ext : false;
      	if(!k || (prevImageType == 'pdf' && k == 1)) {
      		$('#menuFileModal').find('.fa-chevron-left').css('display','none');
      	} else {
      		$('#menuFileModal').find('.fa-chevron-left').css('display','block');
      	}
      	if( k == ($scope.menus.menuFiles.length - 1 ) || (nextImageType == 'pdf')) {
      		$('#menuFileModal').find('.fa-chevron-right').css('display','none');
      	} else {
      		$('#menuFileModal').find('.fa-chevron-right').css('display','block');
      	}
	}
	$scope.goBack = function() {
		window.history.back();
	}
}]);
angular.bootstrap(document.getElementById("vendorMenu"), ['vendorMenuApp']);
